import kusto from "refractor/kusto";
export default kusto;